import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { Checkbox } from '../ui/checkbox';

const NewsletterSection = () => {
  const { translations } = useLanguage();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    consent: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Newsletter signup:', formData);
    alert('Thank you for signing up!');
    setFormData({ firstName: '', lastName: '', email: '', consent: false });
  };

  return (
    <section className="bg-[#D4AF37] py-12">
      <div className="max-w-7xl mx-auto px-4">
        <form onSubmit={handleSubmit} className="flex flex-col lg:flex-row items-center gap-6">
          <h2 className="text-[#0B0B0B] text-3xl md:text-4xl font-bold whitespace-nowrap">
            {translations.newsletterTitle}
          </h2>
          
          <div className="flex flex-col md:flex-row gap-4 flex-1 w-full">
            <input
              type="text"
              placeholder={translations.newsletterPlaceholder.firstName}
              value={formData.firstName}
              onChange={(e) => setFormData({...formData, firstName: e.target.value})}
              className="px-4 py-3 bg-white border-2 border-white focus:border-[#1D1D1D] outline-none flex-1 min-w-[150px]"
              required
            />
            <input
              type="text"
              placeholder={translations.newsletterPlaceholder.lastName}
              value={formData.lastName}
              onChange={(e) => setFormData({...formData, lastName: e.target.value})}
              className="px-4 py-3 bg-white border-2 border-white focus:border-[#1D1D1D] outline-none flex-1 min-w-[150px]"
              required
            />
            <input
              type="email"
              placeholder={translations.newsletterPlaceholder.email}
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="px-4 py-3 bg-white border-2 border-white focus:border-[#1D1D1D] outline-none flex-1 min-w-[200px]"
              required
            />
            <button
              type="submit"
              className="bg-[#CD0000] text-white px-8 py-3 font-bold flex items-center justify-center gap-2 hover:bg-[#c91560] transition-colors whitespace-nowrap"
            >
              {translations.newsletterButton} <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </form>
        
        <div className="flex items-center gap-3 mt-4 justify-center lg:justify-start lg:ml-[200px]">
          <Checkbox
            id="consent"
            checked={formData.consent}
            onCheckedChange={(checked) => setFormData({...formData, consent: checked})}
            className="border-[#0B0B0B] data-[state=checked]:bg-[#0B0B0B] data-[state=checked]:text-[#D4AF37]"
          />
          <label htmlFor="consent" className="text-[#0B0B0B] text-sm cursor-pointer">
            {translations.newsletterConsent}
          </label>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
